// 참고 https://gaemi606.tistory.com/entry/React-JWT-%EC%95%88%EC%A0%84%ED%95%98%EA%B2%8C-%EC%A0%80%EC%9E%A5%ED%95%98%EA%B8%B0-localStorage-%EC%82%AC%EC%9A%A9-X-3
//
//import axios from "axios";
import { setCookie } from "../util/cookie.js";
import { encrypt } from "../util/crypto.js";
import { AccessClient } from "./axiosInstance.js";

/**
 * 로그인
 * @param {*} param0 
 * @returns 
 */
export const login = async ({ username, password }) => {
  const enc_username = encrypt(username);
  const enc_password = encrypt(password);

  let body = {
    username: enc_username,
    password: enc_password,
  };

  // let body = {
  //   username,
  //   password,
  // };

  //console.log("body : ", body);

  try {
    // const response = await axios.post("/api/login", body,
    //   {
    //     withCredentials: true
    //   });

    const response = await AccessClient.post("/api/login", body);
    const {
      status,
      data: {
        data: { displayName, accessToken, refreshToken, roles },
        message,
      },
    } = response;

    if (accessToken) {
      setCookie("accessToken", accessToken);
    }

    if (refreshToken) {
      setCookie("refreshToken", refreshToken);
    }

    const roler = roles && roles.length > 0 ? roles[0] : undefined;
    return { status, displayName, accessToken, refreshToken, roler, message };
  } catch (error) {
    if (error.response) {
      const {
        status,
        data: { message },
      } = error.response;
      return { status, message };
    }
    throw error;
  }
};

/**
 * 로그 아웃
 */
export const logout = async () => {
  //console.log("localStorage set logout!");
  try {
    const response = await AccessClient.post("/api/logout");
    //console.log("logout : ", response);

    window.localStorage.setItem("biggame-logout", Date.now());
    window.localStorage.setItem("biggame-loggedIn", false);
    window.location.href = "/";

    const {
      status,
      data: { message },
    } = response;
    return { status, message };
  } catch (error) {
    throw error;
  }
};

/**
 * 내 정보 가져오기
 *  - 현재는 학생 정보만 가져옵니다.
 * @returns 
 */
export const loadMe = async () => {
  try {
    const response = await AccessClient.get("/api/me");
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data: data, message };
  } catch (error) {
    if (error.response) {
      const {
        status,
        data: { message },
      } = error.response;
      return { status, message };
    }
    throw error;
  }
};



/**
 * CSRF Token
 * @returns 
 */
export const getCsrfToken = async () => {
  try {
    const response = await AccessClient.get("/api/csrf-token");
    //console.log(response)

    const csrfToken = response.data.csrfToken
    // if (csrfToken) {
    //   setCookie("csrfToken", csrfToken);
    // }

    return csrfToken;

  } catch (error) {
    throw error;
  }
}

/**
 * 패스워드 갱신
 * @param {*} param0 
 * @returns 
 */
export const updatePassword = async ({ password, newPassword, newPassword2 }) => {

  let body = {
    password: password,
    new_password: newPassword,
    new_password2: newPassword2
  };

  console.log("body", body)


  try {
    const response = await AccessClient.put("/api/update-password", body);
    const {
      status,
      data: {
        message,
      },
    } = response;

    return { status, message };
  } catch (error) {
    if (error.response) {
      const {
        status,
        data: { message },
      } = error.response;
      return { status, message };
    }
    throw error;
  }
};




/**
 * 테스트 - 로그인
 * @param {*} param0 
 * @returns 
 */
export const testLogin = async ({ username, password }) => {
  const enc_username = encrypt(username);
  const enc_password = encrypt(password);

  let body = {
    username: enc_username,
    password: enc_password,
  };

  try {

    const response = await AccessClient.post("/api/login", body);
    const {
      status,
      data: {
        message,
      },
    } = response;

    return { status, message };
  } catch (error) {
    if (error.response) {
      const {
        status,
        data: { message },
      } = error.response;
      return { status, message };
    }
    throw error;
  }
};
